const recentlyViewed = () => {
    const _this =  document.querySelector('section-recentlyviewed');
    let queryString = getSearchQueryString(_this);
    if (queryString === "") return;
    fetch(`${window.routes.search_url}`.concat("?view=recently-viewed-products&type=product&q=").concat(queryString),{credentials: "same-origin",method: "GET",}).then(function (response) {
        response.text().then(function (content) {
            var tempElement = document.createElement("div");
            tempElement.innerHTML = content; // Set the content
            _this.querySelector(".recently-viewed-products-placeholder").innerHTML = tempElement.querySelector('.recently-viewed-products-placeholder').innerHTML; // By default the section hide the products, so we force the section to be visible
            _this.style.display = 'block';
            const flkty = new Flickity(_this.querySelector(".slider-flickity"), {
                cellAlign: 'left',
                freeScroll: true,
                pageDots: false,
                groupCells: true,
                contain: true
            });
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        });
    });
}
const getSearchQueryString = (_this) => {
    const currentProductId = _this.querySelector('[data-currentProductId]').getAttribute('data-currentProductId')
    let items = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]"); // If we are on a product template, we make sure to remove the main product from the related product
    if (items.includes(currentProductId)) items.splice(items.indexOf(currentProductId), 1);
    return items.map(function (item) {return "id:" + item;}).join(" OR ");
}

if(document.querySelector('section-recentlyviewed') != null){
    recentlyViewed();
}